import { t } from '@lingui/macro';

export const COPY = {
    YEARLY_MONTHLY_PAYMENT_DISCLAIMER: t`You will be charged the subscription fee every month for the duration of your 12-month contract. Your contract will renew automatically on your annual renewal date until you cancel the renewal.`,
    AFTER_YOUR_FREE_TRIAL_ENDS_NO_PRICE: t`After your trial ends, this subscription automatically renews unless cancelled more than 24 hours before the end of trial.`,
    FAMILY_PLAN: t`One membership with 4 Premium+ accounts, unlimited lesson time, access to 10,000+ lessons and popular songs, plus access to learn all 5 instruments with personal progress tracking for each family member.`,
    PREMIUM_ONE_INSTRUMENT: t`1 Premium account, unlimited lesson time, access to hundreds of Yousician lessons and songs, and personal progress tracking.`,
    PREMIUM_ONE_INSTRUMENT_UNLICENSED: t`1 Premium account, unlimited lesson time, access to hundreds of lessons and songs, and personal progress tracking.`,
    ALL_INSTRUMENTS_UNLICENSED: t`Premium on all instruments (guitar, piano, bass, ukulele, and singing), unlimited lesson time and guided lessons, no ads.`,
    ALL_INSTRUMENTS_LICENSED: t`1 Premium+ account, unlimited lesson time, access to 10,000+ lessons and popular songs, plus access to learn all 5 instruments with personal progress tracking.`,
    ALREADY_SUBSCRIBED: t`This page is not available because you're already on your musical journey.`,
    CONGRATULATIONS_LICENSED: {
        ALL_INSTRUMENTS: {
            TRIAL: t`You've unlocked unlimited access to 10,000+ lessons and popular songs across 5 instruments. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to 10,000+ lessons and popular songs across 5 instruments. Let's play!`,
        },
    },
    CONGRATULATIONS_FAMILY: {
        ALL_INSTRUMENTS: {
            TRIAL: t`You've unlocked unlimited access to 10,000+ lessons, popular songs and more across 5 instruments for you and your family. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to 10,000+ lessons, popular songs and more across 5 instruments for you and your family. Let's play!`,
        },
    },
    CONGRATULATIONS_PREMIUM: {
        GUITAR: {
            TRIAL: t`You've unlocked hundreds of Yousician songs and lessons for guitar, plus unlimited lesson time. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked hundreds of Yousician songs and lessons for guitar, plus unlimited lesson time. Let's play!`,
        },
        BASS: {
            TRIAL: t`You've unlocked hundreds of Yousician songs and lessons for bass, plus unlimited lesson time. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked hundreds of Yousician songs and lessons for bass, plus unlimited lesson time. Let's play!`,
        },
        PIANO: {
            TRIAL: t`You've unlocked hundreds of Yousician songs and lessons for piano, plus unlimited lesson time. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked hundreds of Yousician songs and lessons for piano, plus unlimited lesson time. Let's play!`,
        },
        UKULELE: {
            TRIAL: t`You've unlocked hundreds of Yousician songs and lessons for ukulele, plus unlimited lesson time. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked hundreds of Yousician songs and lessons for ukulele, plus unlimited lesson time. Let's play!`,
        },
        VOICE: {
            TRIAL: t`You've unlocked hundreds of Yousician songs and lessons for singing, plus unlimited lesson time. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked hundreds of Yousician songs and lessons for singing, plus unlimited lesson time. Enjoy!`,
        },
    },
    CONGRATULATIONS_UNLICENSED: {
        ALL_INSTRUMENTS: {
            TRIAL: t`You've unlocked unlimited access to learn with lessons for all 5 instruments. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to learn with lessons for all 5 instruments. Let's play!`,
        },
        GUITAR: {
            TRIAL: t`You've unlocked unlimited access to learn with lessons for guitar. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to learn with lessons for guitar. Let's play!`,
        },
        BASS: {
            TRIAL: t`You've unlocked unlimited access to learn with lessons for bass. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to learn with lessons for bass. Let's play!`,
        },
        PIANO: {
            TRIAL: t`You've unlocked unlimited access to learn with lessons for piano. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to learn with lessons for piano. Let's play!`,
        },
        UKULELE: {
            TRIAL: t`You've unlocked unlimited access to learn with lessons for ukulele. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to learn with lessons for ukulele. Let's play!`,
        },
        VOICE: {
            TRIAL: t`You've unlocked unlimited access to learn with lessons for singing. Enjoy!`,
            SUBSCRIPTION: t`You've unlocked unlimited access to learn with lessons for singing. Enjoy!`,
        },
    },
    DISCOUNT_DISCLAIMER_PERIODS: {
        day: t`The discount is applied only for the first day.`,
        month: t`The discount is applied only for the first month.`,
        quarter: t`The discount is applied only for the first 3 months.`,
        semianual: t`The discount is applied only for the first 6 months.`,
        year: t`The discount is applied only for the first year.`,
    },
};
